// dev-ecs-pims environment — points to ECS backend at dev-ecs-pims.lemonaidpims.co.uk
// relative path necessary so that when it is replaced on top of the ../environment.ts, imports will still be reachable
/* eslint-disable @nx/enforce-module-boundaries */
import { InjectionToken } from '@angular/core';
import { constantsDevPIMS } from 'libs/environments/src/lib/environments/common/constants.devphp8';
import { settings } from 'libs/environments/src/lib/environments/common/settings';
import { PIMSEnvironment } from 'libs/environments/src/lib/environments/environments.model';

export const environment: PIMSEnvironment = {
  production: true,
  settings: {
    ...settings,
  },
  constants: {
    ...constantsDevPIMS,
  },
};

export const ENVIRONMENT = new InjectionToken<PIMSEnvironment>('PIMS_ENVIRONMENT');
